export default __webpack_public_path__ + "static/media/YHMCH-Library.349311c5.jpg";